<template>
    <label class="v5-checkbox" role="checkbox" :for="`v5-checkbox-${uuid}`">
        <span class="v5-checkbox__inner" :class="{'is-checked':checked,'is-indeterminate':indeterminate}">
        </span><input :id="`v5-checkbox-${uuid}`" class="v5-checkbox__input" type="checkbox" aria-hidden="true"
            :checked="checked" @change="$emit('change', $event.target.checked)" /><span class="v5-checkbox__label">
            <slot></slot>
        </span>
    </label>
</template>
<script>
import uuidMixin from './../../mixins/uuid';
export default {
    name: 'v5-checkbox',
    mixins: [uuidMixin],
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: { 
        checked: Boolean,
        indeterminate: Boolean
    }
};
</script>
<style lang="scss">
@import './style.scss';
</style>